import {Translate} from "components/common/Translate/Translate";
import {ContentParent} from "components/modules/Content/ContentParent";
import {ContentItem} from "components/modules/Content/ContentItem/ContentItem";
import {Award, FileStack, Gift, Lightbulb, PencilRuler, ShieldCheck} from "lucide-react";

export const WebpResizerFeaturesContent = () => {
    return (
        <ContentParent>
            <ContentItem
                title={<Translate keyName="Instant-WebP-Resizing-title" />}
                description={<Translate keyName="Instant-WebP-Resizing-sub-title" />}
                icon={<Award strokeWidth={1.5} width={30} height={30}/>}
            />
            <ContentItem
                title={<Translate keyName="Enhanced-Resize-Settings-title" />}
                description={<Translate keyName="Enhanced-Resize-Setting-sub-title" />}
                icon={<Lightbulb strokeWidth={1.5} width={30} height={30}/>}
            />
            <ContentItem
                title={<Translate keyName="content-Flexible-Dimension-Control-title" />}
                description={<Translate keyName="content-Flexible-Dimension-Control-sub-title" />}
                icon={<PencilRuler strokeWidth={1.5} width={30} height={30}/>}
            />

            <ContentItem
                title={<Translate keyName="Resize-Anywhere-title" />}
                description={<Translate keyName="Resize-Anywhere-sub-title" />}
                icon={<FileStack strokeWidth={1.5} width={30} height={30}/>}
            />

            <ContentItem
                title={<Translate keyName="High-Quality-title" />}
                description={<Translate keyName="High-Quality-sub-title" />}
                icon={<Gift strokeWidth={1.5} width={30} height={30}/>}
            />
            <ContentItem
                title={<Translate keyName="Flawless-Quality-title" />}
                description={<Translate keyName="Flawless-Quality-sub-title" />}
                icon={<ShieldCheck strokeWidth={1.5} width={30} height={30}/>}
            />
        </ContentParent>
    );
};
